import baseRequest from '../../_core/';
import { loadState } from '../../_core/localStorage';

// Initialize state from localStorage to maintain authentication on page refresh
const localStorageState = loadState();
const initialUser = {
  isAdmin: false,
  loggedIn: localStorageState.loggedIn || false,
  role: localStorageState.role || null,
  token: localStorageState.token || null,
  error: ''
};

const user = (state = initialUser, action) => {
  switch (action.type) {
    case 'INITIALIZE_AUTH_STATE':
      return {
        ...state,
        ...action.payload
      };
    case 'USER_SIGNUP_SUCCESS':
      baseRequest.setLocalStorage({
        ...action.payload,
        isAdmin: false,
        loggedIn: true,
        role: 'user'
      });
      return {
        // ...state,
        ...action.payload,
        loggedIn: true
      };
    case 'USER_SIGNUP_ERROR':
      return {
        // ...state,
        signupError: action.payload
      };
    case 'COMPANY_SIGNUP_SUCCESS':
      baseRequest.setLocalStorage({
        ...action.payload,
        isAdmin: false,
        loggedIn: false,
        role: 'company',
        isConfirmed: false
      });
      return {
        // ...state,
        ...action.payload,
        loggedIn: false,
        role: 'company',
        isConfirmed: false
      };
    case 'COMPANY_SIGNUP_ERROR':
      return {
        // ...state,
        signupError: action.payload
      };
    case 'LOGIN_ADMIN_SUCCESS':
      baseRequest.setLocalStorage({
        ...action.payload,
        // isAdmin: true,
        loggedIn: true
      });
      return {
        ...action.payload,
        loggedIn: true
      };
    case 'USER_LOGIN_SUCCESS':
      baseRequest.setLocalStorage({
        token: action.payload.token,
        isAdmin: false,
        role: 'user',
        loggedIn: true
      });
      return {
        ...action.payload,
        isAdmin: false,
        loggedIn: true
      };
    case 'USER_RESET_PASSWORD_SUCCESS':
      return {
        ...action.payload
      };
    case 'USER_RESET_PASSWORD_ERROR':
      return {
        ...action.payload
      };
    case 'COMPANY_RESET_PASSWORD_SUCCESS':
      return {
        ...action.payload
      };
    case 'COMPANY_RESET_PASSWORD_ERROR':
      return {
        ...action.payload
      };
    case 'USER_LOGIN_ERROR':
      return {
        // ...state,
        loginError: action.payload
      };
    case 'COMPANY_LOGIN_SUCCESS':
      baseRequest.setLocalStorage({
        token: action.payload.token,
        isAdmin: false,
        role: 'company',
        loggedIn: true
      });
      return {
        ...action.payload,
        isAdmin: false,
        loggedIn: true
      };
    case 'COMPANY_LOGIN_ERROR':
      return {
        // ...state,
        loginError: action.payload
      };
    case 'COMPANY_OTP_VERIFIED':
      baseRequest.setLocalStorage({
        token: action.payload.token,
        isAdmin: false,
        role: 'company',
        loggedIn: true,
        isConfirmed: true
      });
      return {
        ...action.payload,
        isAdmin: false,
        loggedIn: true
      };
    case 'LOGOUT_SUCCESS':
      baseRequest.setLocalStorage({
        loggedIn: false,
        isConfirmed: undefined
      });
      baseRequest.clearHeader();
      return { roles: undefined, loggedIn: false, sessionToken: undefined };
    default:
      return state;
  }
};

export default user;
